export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "登入",
    "login.form.hint.user": "登入",
    "login.form.hint.password": "密碼",
    "login.form.checkbox.remember-me": "記住我",
    "login.form.button.sign-in": "登入",
    "login.form.message.invalid-user-credentials": "登入或密碼不正確",
    "login.form.message.user-required": "輸入登入",
    "login.form.message.password-required": "輸入密碼",
    "login.form.button.forgot-password": "忘記密碼?",
    "error.root-admin-login.title": "錯誤 403 – 禁止",
    "error.root-admin-login.message": "您以唯讀系統管理員的身分登入。若要存取 Web Recovery 主控台，請改以客戶租用戶使用者或系統管理員的身分登入"
};
